import 'bootstrap'
import './sass/app.scss'
import 'slick-carousel/slick/slick'
import AOS from 'aos'
import Typewriter from 'typewriter-effect/dist/core';

$(document).ready(function () {
    AOS.init({
        once: false
    });

    $('#openNav').on('click', function () {
        $('#myNav').css("width", "100%");
    });

    $('#closeNav').on('click', function () {
        $('#myNav').css("width", "0%");
    });

    var $slickElement = $('.slick-home');
    var $slickHashtagElement = $('.hashtag-box');
    var $status = $('.pagination > span');
    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        $status.text(i + ' z ' + slick.slideCount);
    });
    $slickElement.slick({
        asNavFor: '.hashtag-box',
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 564,
                settings: {
                    adaptiveHeight: false,
                }
            },
        ]
    });
    $slickHashtagElement.slick({
        asNavFor: '.slick-home',
        fade: true,
    });
    $('.next').click(function () {
        $slickElement.slick('slickNext');
    });
    $('.prev').click(function () {
        $slickElement.slick('slickPrev');
    });
});


jQuery(function ($) {
    $.fn.hScroll = function (amount) {
        amount = amount || 120;
        $(this).bind("DOMMouseScroll mousewheel", function (event) {
            var oEvent = event.originalEvent,
                direction = oEvent.detail ? oEvent.detail * -amount : oEvent.wheelDelta,
                position = $(this).scrollLeft();
            position += direction > 0 ? -amount : amount;
            $(this).scrollLeft(position);
            event.preventDefault();
        })
    };
});

$(document).ready(function () {
    $('.home-posts.scrollbar-default').hScroll(60); // You can pass (optionally) scrolling amount
});

$(document).ready(function () {
    let app = document.getElementById('app');
    if(!app) {
        return;
    }
    let typewriter = new Typewriter(app, {
        loop: true,
        delay: 100,
    });
    let content = JSON.parse(app.dataset.content);
    content.forEach(element => {
        typewriter.typeString('<span class="' + element.color +'">' + element.content +'</span>')
            .pauseFor(1000)
            .deleteAll()
    })
    typewriter.start();
});


